import React from 'react';
import cx from 'classnames';

const baseCx = ['w-[100vw] max-h-[440px]'];

const smCx = ['sm:mx-auto sm:!w-[440px]'];

const lgCx = ['lg:my-0'];

export interface SquareVideoContainerProps {
  children: React.ReactNode;
}

export function SquareVideoContainer({ children }: SquareVideoContainerProps) {
  return <div className={cx(baseCx, smCx, lgCx)}>{children}</div>;
}
